import { render, staticRenderFns } from "./ProgramCoachListComponent.vue?vue&type=template&id=4705ad54&"
import script from "./ProgramCoachListComponent.vue?vue&type=script&lang=js&"
export * from "./ProgramCoachListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports